import * as en_US from './en_US.json';
import * as de_DE from './de_DE.json';
import * as it_IT from './it_IT.json';
import * as fr_FR from './fr_FR.json';
import * as codes from '../assets/country.json';

export const localeText = { en_US, de_DE, fr_FR, it_IT };
export const countryCodes = { ...codes }